import React , {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import {Link} from 'react-router-dom';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import store from '../../store';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const database=firebase.database();

class ReporteGeneralViajesEmpresa extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			prograDia:[],
			rutas:[],
			programas:[],
			clientes:[],
			empleados:[],
			centroCostos:[],
			vehiculos:[],
			reportes:[],
			empresas:[],
			reporte:[],
			horaBajada: [],
			users: [],
			fecha1: new Date(),
			fecha2: new Date(),
			datepicker1:'',
			datepicker2:'',
			tarifas: []

		}	

		this.fecha1 = '';
		this.fecha2 = '';

	}
	
	
	componentDidMount(){

		this.getData(this.state.fecha1, this.state.fecha2);
		
	}

	getData = (fecha1, fecha2) => {
		
		let fechanow = new Date();
		let fechacondicion1 = new Date(fecha1.getFullYear() +'/'+(fecha1.getMonth()+1)+'/'+fecha1.getDate());
		let fechacondicion2 = new Date(fechanow.getFullYear() +'/'+(fechanow.getMonth()+1)+'/'+fechanow.getDate());
		let fechacondicion3 = fechacondicion1;
		// let fechaA = new Date(fecha1);
		let fechaB = new Date(fecha2);
		if (fecha2==='') {
			let fechaA = new Date(fecha1.getFullYear() +'/'+(fecha1.getMonth()+1)+'/'+fecha1.getDate());

			firebase.database().ref().child('ProgramacionDia').orderByChild('fecha').equalTo(String(fechaA)).once('value').then(snap =>{
				let prograDia = [];
				snap.forEach(element => {
					let datos = element.val();
					datos.key = element.key;
					prograDia.push(datos);
				});
	
				this.getDetalles(prograDia);
			})
			
		} else {
			fechacondicion3 = new Date(fecha2.getFullYear() +'/'+(fecha2.getMonth()+1)+'/'+fecha2.getDate());

			let fechaA = new Date(fecha1.getFullYear() +'/'+(fecha1.getMonth()+1)+'/'+fecha1.getDate());
			if (fechacondicion1.getTime() === fechacondicion3.getTime()) {

				firebase.database().ref().child('ProgramacionDia').orderByChild('fecha').equalTo(String(fechaA)).once('value').then(snap =>{
					let prograDia = [];
					snap.forEach(element => {
						let datos = element.val();
						datos.key = element.key;
						prograDia.push(datos);
					});
		
					this.getDetalles(prograDia);
				})
				return null;
			}
			if(fechacondicion3.getTime()>fechacondicion1.getTime()){

				fechacondicion2 = fechacondicion3;
				firebase.database().ref('ProgramacionDia').once('value').then(snap =>{
					let prograDia = [];
					snap.forEach(element => {
						let datos = element.val();
						let date = new Date(datos.fecha)
						if (date.getTime()<=fechacondicion3.getTime()&&date.getTime()>=fechacondicion1.getTime()) {
							datos.key = element.key;
							prograDia.push(datos);
						}
						// else if(){
						// 	datos.key = element.key;
						// 	prograDia.push(datos);
						// }
					});
		
					this.getDetalles(prograDia);
				})
				return null;
			}
			if (fechacondicion1.getTime() === fechacondicion2.getTime()) {
				let fechaA = new Date(fecha1.getFullYear() +'/'+(fecha1.getMonth()+1)+'/'+fecha1.getDate());
				firebase.database().ref().child('ProgramacionDia').orderByChild('fecha').equalTo(String(fechaA)).once('value').then(snap =>{
					let prograDia = [];
					snap.forEach(element => {
						let datos = element.val();
						datos.key = element.key;
						prograDia.push(datos);
					});
		
					this.getDetalles(prograDia);
				})
				return null;
			}
		}
	}

	getDetalles = (prograDia) => {
		firebase.database().ref('Rutas').once('value').then(snapR =>{
			let rutas =[];
			snapR.forEach(element => {
				let datos = element.val();
				datos.key = element.key;
				rutas.push(datos);
			});
			firebase.database().ref('Programacion').once('value').then(snapPro =>{
				let programas = [];
				snapPro.forEach(element => {
					let datos = element.val();
					datos.key = element.key;
					programas.push(datos);
				});
				firebase.database().ref('Clientes').once('value').then(snapCli =>{
					let clientes = [];
					snapCli.forEach(element => {
						let datos = element.val();
						datos.key = element.key;
						clientes.push(datos);
					});
					firebase.database().ref('Empleados').once('value').then(snapEm =>{
						let empleados = [];
						snapEm.forEach(element => {
							let datos = element.val();
							datos.key = element.key;
							empleados.push(datos);
						});
						firebase.database().ref('Vehiculos').once('value').then(snapVe =>{
							let vehiculos = [];
							snapVe.forEach(element => {
								let datos = element.val();
								datos.key = element.key;
								vehiculos.push(datos);
							});
							firebase.database().ref('CentroCosto').once('value').then(snapCC =>{
								let centroCostos = [];
								snapCC.forEach(element => {
									let datos = element.val();
									datos.key = element.key;
									centroCostos.push(datos);
								});
								firebase.database().ref('Empresa').once('value').then(snapE =>{
									let empresas = [];
									snapE.forEach(element => {
										let datos = element.val();
										datos.key = element.key;
										empresas.push(datos);
									});
									firebase.database().ref('Usuarios_Acacya').once('value').then(snapE =>{
										let users = [];
										snapE.forEach(element => {
											let datos = element.val();
											datos.key = element.key;
											users.push(datos);
										});
										firebase.database().ref('TarifasAvianca').once('value').then(snapTa =>{
											let tarifas = [];
											snapTa.forEach(element => {
												let datos = element.val();
												datos.key = element.key;
												tarifas.push(datos);
											});
										this.setState({prograDia, rutas, programas, clientes, empleados, vehiculos, centroCostos, empresas, users, tarifas})
										this.findData();
										})
									})
								})
							})
						})
					})
				})
			})
		})
	}

	findData = () => {
		
		let {prograDia, rutas, programas, clientes, empleados, vehiculos, reportes, empresas, centroCostos, users, tarifas} = this.state;
		let conductorN = '', progra = '', ruta = [],
		vehiculoN = '', cliente = [], reporte = [], empresaN = [], responsableCC = '---', areaDesc = '';
		let numero = 0, codEmple = [], horaSubida = [], horaBajada = [], horaTimbre = [], inicio = '', destino = '',
		fechaSubida = '', fechaBajada = '', length = 0, combinacion = '', tipoV = '---', total = '---', pago = '---', rutaN = '', 
		centroCosto='', solicitante = '',  pasajeros = [], valores = [];

		prograDia.forEach(element => {
			

			let findEmpleados = empleados.find( efind => {
				return element.conductor === efind.key;
			})
			if (findEmpleados!==undefined) {
				conductorN = findEmpleados.nombre;
			}
			else{
				conductorN = '---';
			}
			let findPrograma = programas.find(pfind => {
				return element.programacion === pfind.key;
			})
			if (element.centroC!==undefined) {
				let findCentroCostos = centroCostos.find(ccfind => {
					return element.centroC === ccfind.key;
				})
				centroCosto = findCentroCostos.codigo;
				responsableCC = findCentroCostos.responsable;

				let findEmpresa = empresas.find(emfind => {
					return findCentroCostos.empresa === emfind.key;
				})
				empresaN = findEmpresa.codigo_empresa;
			}
			if (findPrograma!==undefined) {
				progra = findPrograma.vuelo;

				let findSolicitanteEm = empresas.find(sfind => {
					return findPrograma.solicitante === sfind.key;
				})
				if (findSolicitanteEm!==undefined) {
					solicitante = findSolicitanteEm.codigo_empresa;
				}
				let findSolicitanteCl = clientes.find(cfind =>{
					return findPrograma.solicitante === cfind.key;
				})
				if (findSolicitanteCl!==undefined) {
					solicitante = findSolicitanteCl.nombre;
				}
				let findSolicitanteUs = clientes.find(cfind =>{
					return findPrograma.solicitante === cfind.key;
				})
			}
			else{
				progra = '---';
				empresaN = '---';
			}
			let findRutas = rutas.find(rfind => {
				return element.ruta === rfind.key;
			})
			if (findRutas!==undefined) {
				ruta.push(findRutas);
				ruta.forEach(rutasD => {
				inicio = rutasD.inicio.nombre;
				destino = rutasD.destino.nombre;
				combinacion = inicio + ", " + destino;
				rutaN = rutasD.nombRuta;

				let findTarifas = tarifas.find( tfind => {
					return findRutas.tarifa === tfind.key;
				})
				if (findTarifas !== undefined) {
					valores = findTarifas.valores;
					tipoV = findTarifas.tipo;
				}
				
			})
			}
			else{
				ruta='---';
				inicio = '---';
				destino = '---';
				combinacion = '---';
			}
			let findVehiculos = vehiculos.find( vfind => {
				return element.vehiculo === vfind.key;
			})
			
			if (findVehiculos!==undefined) {
				vehiculoN = findVehiculos.movil + ' (' + findVehiculos.placa + ')';
				if (valores !== []) {

					total = valores[findVehiculos.tipo_vehiculo];
					pago = valores[findVehiculos.tipo_vehiculo];
				}
			}
			else{
				vehiculoN = '---';
			}
			if (element.pasajeros!==undefined || element.Pasajeros!==undefined) {
				if (element.pasajeros !==undefined) {
					length = element.pasajeros.length;
					pasajeros = element.pasajeros;
				}
				else{
					length = element.Pasajeros.length;
					pasajeros = element.Pasajeros;
				}
				pasajeros.forEach(data => {
					
					let findClientes = clientes.find( cfind => {
						return data.codigo === cfind.key;
					})
					if (findClientes !== undefined) {
						numero = numero + 1;
						if (findClientes.areaDesc!==undefined) {
							areaDesc = findClientes.areaDesc;
						}

						if (length>1) {
							codEmple = codEmple + findClientes.numero_empleado+', ';
							cliente = cliente + findClientes.nombre+ ', ';
							
							if (data.horaSubida !== "" && data.horaSubida !== undefined) {
								let fecha = new Date(data.horaSubida)
								horaSubida= horaSubida + fecha.getHours() +':'+fecha.getMinutes()+', ';
								fechaSubida = fecha.getDay()+'/'+fecha.getMonth()+'/'+fecha.getFullYear();
							}
							else{
								horaSubida = '---';
								fechaSubida = '---';
							}
							
							if (data.horaLlegada !=="" && data.horaLlegada !== undefined) {
								let fecha = new Date(data.horaLlegada)
								horaBajada=fecha.getHours() +':'+fecha.getMinutes()+', ';
								fechaBajada = fecha.getDay()+'/'+fecha.getMonth()+'/'+fecha.getFullYear();
							}
							else{
								horaBajada = '---';
								fechaBajada = '---';
							}

							if (data.horaTimbre !=="" && data.horaTimbre !== undefined) {
								let fecha = new Date(data.horaTimbre)
								horaTimbre= horaTimbre + fecha.getHours() + ':' +fecha.getMinutes()+', ';
							}else{
								horaTimbre = '---';
							}
						}
						else{
							codEmple=codEmple + findClientes.numero_empleado;
							cliente = cliente + findClientes.nombre;

							if (data.horaSubida !== "" && data.horaSubida !== undefined) {
								let fecha = new Date(data.horaSubida)
								horaSubida= horaSubida + fecha.getHours() +':'+fecha.getMinutes();
								fechaSubida = fecha.getDay()+'/'+fecha.getMonth()+'/'+fecha.getFullYear();
							}
							else{
								horaSubida = '---';
								fechaSubida = '---';
							}
							if (data.horaLlegada !=="" && data.horaLlegada!== undefined) {
								let fecha = new Date(data.horaLlegada)
								horaBajada=  horaBajada + fecha.getHours() +':'+fecha.getMinutes();
								fechaBajada = fecha.getDay()+'/'+fecha.getMonth()+'/'+fecha.getFullYear();
							}
							else{
								horaBajada = '---';
								fechaBajada = '---';
							}
							if (data.horaTimbre !=="" && data.horaTimbre !== undefined) {
								let fecha = new Date(data.horaTimbre)
								horaTimbre= horaTimbre + fecha.getHours() + ':' +fecha.getMinutes();
							}else{
								horaTimbre = '---';
							}
						}
					}
					length = length - 1;
				});
				length = 0;
			}
			else{
				areaDesc = '---';
				codEmple = '---';
				cliente = '---';
				horaSubida = '---';
				horaTimbre = '---';
				horaBajada = '---';
				fechaSubida = '---';
				fechaBajada = '---';
			}
			
			reporte.push({
				conductor:conductorN, 
				programacion:progra, 
				ruta, vehiculo: vehiculoN, 
				personas:cliente, empresa:empresaN, 
				numero, numero_empleado:codEmple, 
				centro:centroCosto, 
				responsable:responsableCC, 
				areaDesc, horaSubida, horaBajada,
				horaTimbre, desde:inicio,
				lugar:destino, combinacion,
				cantTrayec:1, fechaSubida, fechaBajada, tipoV, total, solicitante, pago, rutaN, progra});
			cliente = [];
			vehiculoN = '';
			progra = '';
			ruta = [];
			empresaN = '';
			conductorN = [];
			numero = 0;
			codEmple = [];
			horaSubida = [];
			areaDesc = '';
			horaBajada = [];
			horaTimbre = [];
			inicio = '';
			destino = '';
			fechaSubida = '';
			fechaBajada = '';
			rutaN = '';
			centroCosto='';
			solicitante='';
			total = '---';
			pago = '---';
			tipoV = '---';
		})
		this.setState({reporte})

	}
	
	
	handleChangeDatePicker1(){
		// this.setState({fecha2:''});

		let fecha1=this.fecha1.value;
		this.fecha2.value = 'dd/mm/aaaa';
		// let fecha2=this.fecha2.value;
		let splitfecha = fecha1.split("-");

		let formatdate = new Date(splitfecha[0]+'/'+splitfecha[1]+'/'+splitfecha[2]);
		// this.fecha1.value = formatdate;
		this.getData(formatdate, '');
		// console.log(fecha2);
		
	}
	
	handleChangeDatePicker2(){
		
		let fecha1=this.fecha1.value;
		let fecha2=this.fecha2.value;
		let splitfecha1 = fecha1.split("-");
		let splitfecha2 = fecha2.split("-");

		let formatdate1 = new Date(splitfecha1[0]+'/'+splitfecha1[1]+'/'+splitfecha1[2]);
		let formatdate2 = new Date(splitfecha2[0]+'/'+splitfecha2[1]+'/'+splitfecha2[2]);
		this.getData(formatdate1, formatdate2);

	}
	
	render(){
		let {prograDia, progra, conductor, reporte} = this.state;
		
		return(
				<div className="Rrporte container">
						<h1>Reporte de viajes empresas</h1>
						
						
						<div className="row">
							<div className="col-md-3">									
							</div>
							<div className="col-md-3 col-xs-6">	
								<div className="form-group">
									<label htmlFor=" fecha1">Fecha Inicio</label>
									<input type="date" name="fecha1" className="form-control" onChange={this.handleChangeDatePicker1.bind(this)} 
									ref={input=>{this.fecha1=input} }
									/>
								</div>
							</div>
							<div className="col-md-3 col-xs-6">
								<div className="form-group">
									<label htmlFor="fecha2">Fecha Final</label>
									<input type="date" name="fecha2" className="form-control"  
									onChange={this.handleChangeDatePicker2.bind(this)} ref={input=>{this.fecha2=input}}
									/>
								</div>
							</div>
							
						</div>

						<div className="col-lg-6 col-sm-6 col-md-6">
                                    <ExcelFile element={<button style={{marginLeft: 10}} className="btn btn-success">Exportar Excel</button>}>
                                        <ExcelSheet data={this.state.reporte} name="Tes">									
                                            <ExcelColumn label="Empresa" value="empresa" />
											<ExcelColumn label="Conductor" value="conductor"/>
                                            <ExcelColumn label="Centro" value="centro"/>
											<ExcelColumn label="Area de descargue" value="areaDesc"/>
											<ExcelColumn label="Responsable de centro de costos" value="responsable"/>
                                            <ExcelColumn label="Vehiculo" value="vehiculo"/>
                                            <ExcelColumn label="Numero" value="numero"/>
											<ExcelColumn label="Personas" value="personas"/>
                                            <ExcelColumn label="Fecha Subida" value="fechaSubida"/>
											<ExcelColumn label="Hora Subida" value="horaSubida"/>
											<ExcelColumn label="Hora Timbre" value="horaTimbre"/>
											<ExcelColumn label="Hora Bajada" value="horaBajada"/>
											<ExcelColumn label="Fecha Bajada" value="fechaBajada"/>
											<ExcelColumn label="Pago" value="pago"/>
											<ExcelColumn label="Desde" value="desde"/>
											<ExcelColumn label="Hacia" value="lugar"/>
											<ExcelColumn label="Combinacion" value="combinacion"/>
											<ExcelColumn label="Tarifa aplicada" value="tipoV"/>
											<ExcelColumn label="Cantidad de trayectos" value="cantTrayec"/>
											<ExcelColumn label="Precio aplicado" value="total"/>
											<ExcelColumn label="Solicitante del servicio" value="cliente"/>
											<ExcelColumn label="Codigo empleado" value="numero_empleado"/>
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
							
						<BootstrapTable data={ this.state.reporte }
							 ref='table'			 
							 pagination={ true }
							 search={ true }
							 hover
							 >	
							 	<TableHeaderColumn width={this.state.anchoActual>600?'0':'230'}  dataField='rutaN' dataAlign='center' dataSort={true} >Rutas</TableHeaderColumn>
								 {/* <TableHeaderColumn width={this.state.anchoActual>600?'0':'230'}  dataField='progra' dataAlign='center' dataSort={true} >Viaje</TableHeaderColumn> */}
							 	<TableHeaderColumn width={this.state.anchoActual>600?'0':'230'}  dataField='empresa' dataAlign='center' dataSort={true} >Empresa</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'250'} dataField='conductor' dataSort={true}>Conductor</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'155'} dataField='centro' dataSort={true}>Centro de costos</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'185'} dataField='areaDesc' dataAlign='center' dataSort={true}>Area de descargue</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'300'} dataField='responsable' dataSort={true}>Responsable de centro de costos</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'155'} dataField='vehiculo' dataAlign='center' dataSort={true}>Unidad</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'200'} dataField='numero' dataAlign='center' dataSort={true}>Personas en viaje</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'300'} dataField='personas' dataSort={true}>Nombres (pasajeros)</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'180'} dataField='fechaSubida'  dataAlign='center' dataSort={true}>Fecha Subida</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'180'} dataField='horaSubida' dataAlign='center' dataSort={true}>Hora subida</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'180'} dataField='horaTimbre' dataAlign='center' dataSort={true}>Hora timbre</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'180'} dataField='horaBajada' dataAlign='center' dataSort={true}>Hora bajada</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'180'} dataField='fechaBajada' dataAlign='center' dataSort={true}>Fecha Bajada</TableHeaderColumn>	
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='pago' dataAlign='center' dataSort={true}>Pago</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'280'}  dataField='desde' dataAlign='center' dataSort={true}>Desde</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'280'}  dataField='lugar' dataAlign='center' dataSort={true}>Hacia</TableHeaderColumn>
								
								
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'550'}  dataField='combinacion' dataAlign='center' dataSort={true}>Combinacion de rutas</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'}  dataField='tipoV' dataAlign='center' dataSort={true}>Tarifa aplicada</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'200'}  dataField='cantTrayec' dataAlign='center' dataSort={true}>Cantidad de trayectos</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'}  dataField='total' dataAlign='center' dataSort={true}>Precio aplicado</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'250'}  dataField='solicitante' dataAlign='center' dataSort={true}>Solicitante del servicio</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'280'}  dataField='numero_empleado' dataAlign='center'  dataSort={true} >Codigo empleado</TableHeaderColumn>				 							 							 
						  </BootstrapTable>
									
						
						
				
				
				</div>
		
		
		)	
	}
}

export default ReporteGeneralViajesEmpresa;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteGeneralViajesEmpresa.js